import { FileTextOutlined, DownloadOutlined } from '@ant-design/icons';

import { Timeline, Space, Tag, Typography, Divider, Tabs, message } from 'antd';
import moment from 'moment';

import ModalWrapper from './ModalWrapper';
import { DownloadViaLink, getColor, getError, getHistoryClient, getLabel } from '../../clientUtils';

const { Text, Title } = Typography;

const documentTagColor = {
  GENERATED: 'green',
  CRN_GENERATED: 'yellow',
  CANCELLED: 'red'
};

const HistoryModal = ({ title, isOpen, onCancel, comments, loading, history, attachmentHistoryData }) => {
  const historyArr = comments?.length ? comments : history;

  const handleFileDownload = async (id, fileName) => {
    try {
      const response = await getHistoryClient().v1CommonEventHistoryIdPresignedURL(id);
      DownloadViaLink(response?.data?.data, fileName);
    } catch (error) {
      message.error(getError(error));
    }
  };

  const transitionItems = historyArr?.map((comment) => ({
    children: (
      <Space className="w-100" direction="vertical">
        <Space align="start" className="w-100 jc-space-between" size="small">
          <div className="w-100">
            <Title level={5}>{title}</Title>
            <Text type="secondary">
              {moment(comment?.updated_on).format('DD MMM YYYY')} at {moment(comment?.updated_on).format('hh:mm A')} by{' '}
              {comment?.updated_by}
            </Text>
          </div>
          <Tag
            bordered={false}
            className="br-20 fw-500"
            color={getColor(comment?.state)}
            style={{ marginRight: 0, fontSize: 11 }}>
            {getLabel(comment?.state)}
          </Tag>
        </Space>
        <Text>{comment?.comments}</Text>
        <Divider style={{ margin: '10px 0' }} />
      </Space>
    )
  }));

  const documentsItems = attachmentHistoryData
    ?.filter((comment) => comment?.attachment_type !== 'E_INVOICE' && comment?.attachment_type !== 'SIGNED_QR_CODE')
    .map((comment) => ({
      dot: <FileTextOutlined />,
      children: (
        <Space className="w-100" direction="vertical">
          <Space align="start" className="w-100 jc-space-between" size="small">
            <div className="w-100">
              <Title
                className="pointer accent-color"
                level={5}
                onClick={() => handleFileDownload(comment?.id, getLabel(comment?.event))}>
                {getLabel(comment?.label)} <DownloadOutlined />
              </Title>
              <Text type="secondary">
                {moment(comment?.updated_on).format('DD MMM YYYY')} at {moment(comment?.updated_on).format('hh:mm A')}{' '}
                by {comment?.updated_by}
              </Text>
            </div>
            <Tag
              bordered={false}
              className="br-20 fw-500"
              color={documentTagColor[comment?.status]}
              style={{ marginRight: 0, fontSize: 11 }}>
              {getLabel(comment?.status)}
            </Tag>
          </Space>
          <Text>{comment?.comments}</Text>
          <Divider style={{ margin: '10px 0' }} />
        </Space>
      )
    }));

  const transitionTimeline = <Timeline items={transitionItems} />;
  const documentsTimeline = <Timeline items={documentsItems} />;

  const tabItems = [
    ...(historyArr.length
      ? [
          {
            key: '1',
            label: 'History',
            children: transitionTimeline
          }
        ]
      : []),
    ...(attachmentHistoryData?.length
      ? [
          {
            key: '2',
            label: 'Document History',
            children: documentsTimeline
          }
        ]
      : [])
  ];

  const hasContent = (historyArr?.length || attachmentHistoryData?.length) && !loading;
  const content = hasContent ? (
    <Tabs defaultActiveKey="1" items={tabItems} />
  ) : (
    <Space className="mb-30 mt-30">
      <Text>History is not available. Please reach out to posi-tech@mensabrands.com </Text>
    </Space>
  );

  return (
    <ModalWrapper
      className="history-modal"
      content={content}
      footer={[]}
      loading={loading}
      onCancel={onCancel}
      open={isOpen}
      title="History"
      width={700}
    />
  );
};

export default HistoryModal;
